module.exports = __webpack_public_path__ + "static/seo-home-881c34182b5371bd99d2d4bb0fc58726.png";